<template>
    <div :id="this.id" class="accordion-item" :class="{'is-active': active}">
        <div class="accordion-item-title">
            <button @click="toggle" class="accordion-item-trigger" :class="{'hasTitle': !item.icon}">
                <ActionBar ref="actionBar" @accordionAction="$emit('accordionAction')"
                           @copyElement="$emit('copyElement')"
                           @deleteElement="deleteSelf" :icon="item.icon"
                           :title="item.title ? item.title : this.fullTitle"
                           :copyAllowed="getComponentProps.copyAllowed"
                           :disableIcons="item.disableActionIcons"
                           :status="item.status" :status-visible="item.statusVisible"></ActionBar>
                <span class="accordion-item-trigger-icon"></span>
            </button>
        </div>
        <transition
                name="accordion-item"
                @enter="startTransition"
                @after-enter="endTransition"
                @before-leave="startTransition"
                @after-leave="endTransition">
            <div :class="['accordion-item-details',active ? 'accordion-item-enter-active':'activeHide accordion-item-leave-active accordion-item-leave-to']">
                <div class="accordion-item-details-inner">
                    <component :index="index" :is="this.getComponentName" v-bind="getComponentProps"
                               :dynamicProps="dynamicProps"></component>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import TabExample from "../buttons/TabExample";
    import ActionBar from "./ActionBar";
    import MediumContent from "../../views/campaign/show/MediumContent";
    import Medium from "../../views/campaign/edit/Medium";
    import Space from "../../views/trackingList/Space";

    export default {
        name: "AccordionItem",
        components: {Space, Medium, MediumContent, ActionBar, TabExample},
        props: ['item', 'multiple', 'dynamicProps', 'dynamicName', 'index'],
        data: function () {
            return {
                id: this.item.itemComponentProps.type + '-' + this.index,
                active: this.item.active ? this.item.active : (this.index === 0)
            };
        },
        methods: {
            toggle(event) {
                if (this.multiple) this.active = !this.active;
                else {
                    this.$parent.$children.forEach((item) => {
                        if (item.$el.id === event.currentTarget.parentElement.parentElement.id) this.active = !this.active;
                        else this.active = false
                    })
                }
                this.$emit('toggle', {'active': this.active, 'index': this.index});
            },

            startTransition(el) {
                el.style.height = el.scrollHeight + 'px'
            },

            endTransition(el) {
                el.style.height = ''
            },
            deleteSelf() {
                this.$emit('deleteElement', this.index);
            },
            twoDigitize: function (number) {
                return ("0" + number).slice(-2);
            },
        },
        computed: {
            'getComponentName': function () {
                return this.dynamicName;
            },
            'getComponentProps': function () {
                return this.dynamicProps;
            },
            'fullTitle': function () {
                return this.item.itemComponentProps.componentType + ' ' + this.twoDigitize(this.index + 1) + ': ' + this.item.itemComponentProps.type + ' ' + (this.item.itemComponentProps.name ? this.item.itemComponentProps.name : '');
            }
        }
    }
</script>

<style lang="scss" scoped>

    button:focus {
        outline: 0;
    }

    .accordion-item-title {
        background-color: #fff;
        position: relative;
        height: 50px;

        h4 {
            font-size: 1.25rem;
            margin-bottom: 0;
            padding-right: 1.25rem;
        }
    }

    .accordion-item-trigger {
        width: 100%;
        text-align: left;
        background-color: transparent;
        border: none;
    }

    .accordion-item-trigger-icon {
        $size: 13px;
        display: block;
        position: absolute;
        top: 0;
        right: 1.25rem;
        bottom: 0;
        margin: auto;
        width: $size;
        height: $size;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(calc(#{-$size} / 4)) rotate(45deg);
        transition: transform 0.2s ease;

        .is-active & {
            transform: translateY(calc(#{-$size} / 4)) rotate(225deg);
        }
    }

    .accordion-item-details {
        overflow: hidden;
        background-color: #F2F2F4;
    }

    .accordion-item-enter-active, .accordion-item-leave-active {
        will-change: height;
        transition: height 0.2s ease;
    }

    .accordion-item-enter, .accordion-item-leave-to {
        height: 0 !important;
    }

    .activeHide {
        height: 0px;
        -webkit-transition: height 0.5s linear;
        -moz-transition: height 0.5s linear;
        -ms-transition: height 0.5s linear;
        -o-transition: height 0.5s linear;
        transition: height 0.5s linear;
    }

    .accordion-item {
        margin-bottom: 10px;
    }

    .hasTitle {
        padding-left: 20px;
    }
</style>